import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { WpPageLayout, WpPageHeader, WpPageBody, WpPageTitle, WpPageUtilityNavBar } from 'Wpds/components/page-layout';
import WpToastManager from 'Wpds/components/toast/WpToastManager';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import { getManagerAssistantSettings } from 'Shared/actions/user';
import Spinner from 'Shared/components/Spinner';
import PageUrls from 'Shared/constants/PageUrls.constants';
import FeedbackPrompt from './FeedbackPrompt/FeedbackPrompt';
import GiveKudosPrompt from './GiveKudosPrompt/GiveKudosPrompt';

function AssistantsManagerSettings() {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    async function fetchManagerAssistantSettings() {
      try {
        setIsLoading(true);
        const response = await dispatch(getManagerAssistantSettings());
        if (!response || response.status !== 200) WpToastManager.danger('Something went wrong!');
        setIsLoading(false);
      } catch (e) {
        WpToastManager.danger('Something went wrong!');
        setIsLoading(false);
      }
    }

    fetchManagerAssistantSettings();
  }, []);

  const handleBackToAssisstantsPageClick = () => {
    history.push(PageUrls.ASSISTANTS_PAGE);
  };

  const learnMoreRedirectLink =
    'https://docs.predictiveindex.com/perform/my-profile/assistant-settings/what-is-manager-assistant/';
  const handleLearnMoreButtonClick = () => window.open(learnMoreRedirectLink);

  return (
    <WpPageLayout width="container" className="AssistantsPage">
      <WpPageUtilityNavBar>
        <div className="d-flex align-items-center justify-content-between">
          <WpButton size="sm" variant="tertiary" onClick={handleBackToAssisstantsPageClick}>
            <WpIcon name="angle-left" />
            Assistants
          </WpButton>
          <WpButtonGroup>
            <WpButton variant="tertiary" size="sm" onClick={handleLearnMoreButtonClick}>
              <WpIcon name="question-circle" />
              Learn More
            </WpButton>
          </WpButtonGroup>
        </div>
      </WpPageUtilityNavBar>
      <WpPageHeader>
        <WpPageTitle
          title="Manager Assistant Settings"
          subTitle="The manager assistant helps you and your team stay in sync. The settings below will be set for your whole
        company."
        />
      </WpPageHeader>
      <WpPageBody>
        <div className="d-flex flex-column">
          {isLoading ? (
            <Spinner activeIf />
          ) : (
            <>
              <div className="mb-3">
                <FeedbackPrompt />
              </div>
              <div className="mb-3">
                <GiveKudosPrompt />
              </div>
            </>
          )}
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
}

export default AssistantsManagerSettings;
